import { Dispatch, SetStateAction } from 'react';
import Select from '../../../select';
import { useTranslation } from 'react-i18next';

interface FireRatingSelectProps {
  fireRatingIndex: number;
  setFireRatingIndex: Dispatch<SetStateAction<number>>
}

const FireRatingSelect = ({fireRatingIndex, setFireRatingIndex}: FireRatingSelectProps) => {
  const {t} = useTranslation();

  const minutes = t('concrete.structuralElements.disclaimer.fireResistance.list')
    .split(';')
    .map((value, index) =>
      {
        return {
          id: index,
          name: `${value} ${t('concrete.structuralElements.disclaimer.fireResistance.minutes')}`,
        };
      }
    );

  return (
      <Select
        label={t('concrete.structuralElements.disclaimer.fireResistance.chooseFireRating') ?? ''}
        items={minutes}
        value={fireRatingIndex.toString()}
        id={'chooseFireRating'}
        onChange={(value: string) => setFireRatingIndex(Number(value))}
      />
  );
};

export default FireRatingSelect;